import { render } from "./removeItem.vue?vue&type=template&id=d298a5e2"
import script from "./removeItem.vue?vue&type=script&lang=js"
export * from "./removeItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__